import React from 'react';
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { useTranslation } from 'react-i18next';
import { Download, Print } from '@mui/icons-material';
import { QrCodeControlsProps } from '../../types';
import { qrSizes } from '../../hooks/useQrCode';

export const QrCodeControls: React.FC<QrCodeControlsProps> = React.memo(
  ({
    customText,
    selectedSize,
    isDownloading,
    onCustomTextChange,
    onSizeChange,
    onDownload,
    onPrint,
  }) => {
    const { t } = useTranslation();

    return (
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <TextField
          label={t('qr-code.custom-text.label')}
          placeholder={t('qr-code.custom-text.placeholder')}
          value={customText}
          onChange={(e) => onCustomTextChange(e.target.value)}
          fullWidth
          multiline
          rows={2}
        />

        <FormControl fullWidth>
          <InputLabel>{t('qr-code.size.label')}</InputLabel>
          <Select
            value={selectedSize}
            label={t('qr-code.size.label')}
            onChange={(e) => onSizeChange(e.target.value as number)}
          >
            {qrSizes.map((size) => (
              <MenuItem key={size.value} value={size.value}>
                {size.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <Box sx={{ display: 'flex', gap: 2 }}>
          <LoadingButton
            sx={{ flex: '1 1 160px' }}
            variant="contained"
            color="primary"
            startIcon={<Download />}
            onClick={onDownload}
            loading={isDownloading}
          >
            {t('qr-code.actions.download')}
          </LoadingButton>
          <LoadingButton
            sx={{ flex: '1 1 160px' }}
            variant="outlined"
            color="primary"
            startIcon={<Print />}
            onClick={onPrint}
          >
            {t('qr-code.actions.print')}
          </LoadingButton>
        </Box>
      </Box>
    );
  }
);

QrCodeControls.displayName = 'QrCodeControls';
